import type { NotFoundConfig } from '@/types';
import { LangType } from '@/utils';

// 在5.1.0版本之后，app传递的语言参数之前不一致，需要做映射 例如：zh_TW -> tw
export const NEW_REQUEST_LANG_MAP: any = {
    zh_TW: 'tw', // 中国台湾繁体中文
    pt_BR: 'br', // 巴西葡萄牙语
    pl_PL: 'pl', // 波兰语
    cs_CZ: 'cz', // 捷克语
    hu_HU: 'hu', // 匈牙利语
    sv_SE: 'se', // 瑞典语
};

// 404页面重定向配置
export const notFoundConfig: NotFoundConfig = {
    'energyreport/report-list': 'energyreport',
};

export const API_SUCCESS_CODE = '0';

// 设备未找到的错误码
export const DEVICE_NOT_FIND_CODE = '2005';

export const BRIDGE_SUCCESS_CODE = 0;

export enum GlobalStateEnum {
    SITE = 'site',
    LANG = 'lang',
    ONLINE = 'onLine',
    TOKEN = 'token',
    VERSION = 'version',
    CODE = 'code',
    ACCOUNT = 'account',
}

export const APP_TOKEN_KEY = 'appToken';

export const ECON = 'econ';

export const ECON_KEY = '7473c2977f8181b2';

export const ECON_IV = 'cc5a71f609dc05e4';

// 默认语言
export const DEFAULT_LANG = 'us';

export const DEFAULT_COUNTRY_CODE = 'US';

// 语言
export const REQUEST_LANG_MAP = {
    us: 'en_US',
    jp: 'ja_JP',
    cn: 'zh_CN',
    fr: 'fr_FR',
    de: 'de_DE',
    it: 'it_IT',
    ko: 'ko_KR',
    kr: 'ko_KR',
    ru: 'ru_RU',
    es: 'es_ES',
    nl: 'nl_NL',
    uk: 'uk_UA', // 乌克兰语
    ua: 'uk_UA', // 乌克兰语
    tw: 'zh_TW', // 中国台湾繁体中文
    br: 'pt_BR', // 巴西葡萄牙语
    pl: 'pl_PL', // 波兰语
    cz: 'cs_CZ', // 捷克语
    hu: 'hu_HU', // 匈牙利语
    se: 'sv_SE', // 瑞典语
};

export type LangMapType = {
    [key in LangType]: string;
};

export const REQUEST_HEADERS_LANG_LIST: LangMapType = {
    us: 'en-us',
    jp: 'ja-jp',
    cn: 'zh-cn', // 中国大陆简体中文
    fr: 'fr-fr',
    de: 'de-de',
    it: 'it-it',
    ko: 'ko-kr',
    kr: 'ko-kr', // 韩国语
    ru: 'ru-ru',
    es: 'es-es',
    nl: 'nl-nl',
    uk: 'uk-ua', // 乌克兰语
    ua: 'uk-uk', //乌克兰语
    tw: 'zh_TW', // 中国台湾繁体中文
    br: 'pt_BR', // 巴西葡萄牙语
    pl: 'pl_PL', // 波兰语
    cz: 'cs_CZ', // 捷克语
    hu: 'hu_HU', // 匈牙利语
    se: 'sv_SE', // 瑞典语
};

export const acceptLang: any = {
    'en-US': 'us',
    'ja-JP': 'jp',
    'zh-CN': 'cn',
    'fr-FR': 'fr',
    'de-DE': 'de',
    'it-IT': 'it',
    'ko-KR': 'ko',
    'ru-RU': 'ru',
    'es-ES': 'es',
    'nl-NL': 'nl',
    'uk-UA': 'uk', // 乌克兰语
    'zh-TW': 'tw', // 台湾繁体中文
    'pt-BR': 'br', // 巴西葡萄牙语
    'pl-PL': 'pl', // 波兰语
    'cs-CZ': 'cz', // 捷克语
    'hu-HU': 'hu', // 匈牙利语
    'sv-SE': 'se', // 瑞典语
};

export const sitesLang = ['us', 'ja', 'jp', 'cn', 'zh', 'fr', 'it', 'ko', 'kr', 'nl', 'ru', 'de', 'es', 'uk', 'ua', 'tw', 'br', 'pl', 'cz', 'hu', 'se'];
